/*
 * aiClerk 调试设置 — hook 包装 useSelector, 集中类型, 业务侧 import 单一入口.
 */
import { useSelector } from 'react-redux'
import type { RootState } from '../../../app/store'
import type { AiClerkSettingsState } from '../../../slices/aiClerkSettingsSlice'

export function useAiClerkSettings(): AiClerkSettingsState {
  return useSelector(
    (s: RootState) => s.aiClerkSettings as AiClerkSettingsState
  )
}
